(function LivePlannerLanding($, Adzuki)
{
	"use strict";

	var ongoing_interval = null;

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/LivePlanner/landing/'], function onload()
		{
			$('.live-planner-landing-item').click(function _link(e) {
				var url = $(this).data('url');
				e.preventDefault();

				document.location = url;
			});

			$('.lp-get-started').click(function _onClick(e) {
				var $modal = $('.modal');

				e.preventDefault();

				$modal.find('.modal-title').text($(this).data('title'));

				Adzuki.Ajax.get('/LivePlanner/getBrowserInfo')
				.then(function _getBrowserInfo(response) {
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});

			// every 30 seconds, check if there's an ongoing session for this client
			if ($('.join-lp-session-link').length === 0) {
				ongoing_interval = window.setInterval(
					function ongoingSession() {
						_checkForActiveSession();
					},
					30000
				);
			}
		});
	});

	function _checkForActiveSession()
	{
		Adzuki.Ajax.get('/LivePlanner/checkForActiveSession')
		.then(function checkForActiveSession(response) {
				if (typeof response !== 'string') {
					return;
				}

				// insert button into DOM
				$(response).insertBefore('.live-planner-landing-items');

				// stop the interval
				window.clearInterval(ongoing_interval);

				ongoing_interval = null;
			}
		);
	}
}(jQuery, window.Adzuki || {}));
